// customer-reviews-slider.js
// Self-contained: loads Swiper from CDN if not already available

(function () {
  var LOG_PREFIX = "[customer-reviews]";

  function log(msg) {
    console.log(LOG_PREFIX + " " + msg);
  }

  function loadSwiper(callback) {
    if (window.Swiper) {
      log("Swiper already loaded");
      callback();
      return;
    }
    log("Loading Swiper from CDN...");
    var link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
    document.head.appendChild(link);

    var script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
    script.onload = function () {
      log("Swiper loaded from CDN");
      callback();
    };
    script.onerror = function () {
      console.error(LOG_PREFIX + " Failed to load Swiper from CDN");
    };
    document.head.appendChild(script);
  }

  function initReviewsSlider() {
    var swiperEl = document.querySelector(".reviewSwiper");
    if (!swiperEl) {
      log("No .reviewSwiper element found, skipping init");
      return;
    }
    log("Initializing Swiper carousel...");
    var speed = parseInt(swiperEl.dataset.speed || 5000);
    var swiper = new Swiper(".reviewSwiper", {
      slidesPerView: "auto",
      spaceBetween: 15,
      centeredSlides: false,
      loop: true,
      speed: speed,
      autoplay: { delay: 1, disableOnInteraction: false },
      allowTouchMove: true,
      grabCursor: true,
      freeMode: { enabled: false },
    });
    log("Swiper initialized (speed=" + speed + "ms)");
  }

  function setupClaimButton() {
    var claimButton = document.querySelector(".claim-button");
    if (claimButton) {
      log("Claim button found");
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    log("DOMContentLoaded — starting init");
    loadSwiper(function () {
      initReviewsSlider();
      setupClaimButton();
    });
  });
})();

function scrollToTop(event) {
  event.preventDefault();
  window.scrollTo({ top: 0, behavior: "smooth" });
}
